import TitleH1 from "../Titles/title-h1";
import React, {useEffect, useRef, useState} from "react";
import api from "../../services/api";
import author from "../Authors/Author";
import {FlashMessage} from "../assets/utils";
import ModalButton from "./ModalButton";
import ModalForm from "./ModalForm";
import HeaderTable from "./HeaderTable";
import EditButton from "./EditButton";
import DeleteButton from "./DeleteButton";

const AdminAuthors = () => {
    const [authors, setAuthors] = useState([]);
    const [authorName, setAuthorName] = useState('');
    const [edit, setEditing] = useState(false);
    const [flashMessage, setFlashMessage] = useState(null)
    const authorInputRef = useRef(null);
    const [modalOpen, setModalOpen] = useState(null);

    useEffect(() => {
        api.get('/handleAuthors')
            .then(result => (
                setAuthors(result.data.authors)
            ))
            .catch(error => console.log(error))
    }, []);

    const handleEdit = (id) => {
        setEditing(id);
    }

    const showMessage = (message) => {
        setFlashMessage(message);
    }
    const handleCloseFlashMessage = () => {
        setFlashMessage(null)
    }

    useEffect(() => {
        if (edit !== null && authorInputRef.current) {
            authorInputRef.current.focus();
        }
    }, [edit]);

    const handleDelete = (id) => {
        api.delete(`/deleteAuthor/${id}`)
            .then(response => {
                setAuthors(prevAuthors => prevAuthors.filter(author => author.id !== id));
                showMessage(response.data.message);
            })
            .catch(error => {
                    console.error('Error deleting author:', error);
                    showMessage(error.response.data.message);
                }
            )
    }

    const handleUpdate = (updatedAuthor) => {
        console.log('updated')
        api.post(`/updateAuthor/${updatedAuthor.id}`, updatedAuthor)
            .then(response => {
                setAuthors((prevAuthors) =>
                    prevAuthors.map((a) =>
                        a.id === author.id ? {...a, name: author.name} : a
                    )
                );
                showMessage(response.data.message);
                setEditing(null);
            }).catch(error => {
            console.error('Error updating author:', error);
            showMessage(error.response.data.message);
        })
    }

    const handleBlur = () => {
        setEditing(null);
    }

    const handleChange = (event, author) => {
        setAuthors((prevAuthors) =>
            prevAuthors.map((a) =>
                a.id === author.id ? {...a, name: event.target.value} : a))
    }

    const handleKeyDown = (event, updatedAuthor) => {
        if (event.key === 'Enter') {
            handleUpdate(updatedAuthor);
        }
    }

    const handleModalStatus = () => {
        setModalOpen(!modalOpen);
    }

    const submitNewAuthor = () => {
        api.post('/addNewAuthor', {name: authorName})
            .then(response => {
                setAuthors(prevAuthors => [...prevAuthors, response.data.author])
                showMessage(response.data.message);
                setAuthorName('');
                handleModalStatus();
            })
            .catch(error => {
                    console.log(error);
                    showMessage(error.response.data.message);
            })
    }

    const handleAuthorName = (event) => {
        setAuthorName(event.target.value);
    }


    return (
        <>
            <TitleH1>Authors</TitleH1>
            <h2 className="text-2xl font-bold mb-6 text-gray-800">List of Authors</h2>
            <div className="overflow-x-auto">
                <table className="w-full border-collapse bg-white rounded-lg shadow">
                    <HeaderTable headers={['Name', 'Edit', 'Delete']}/>
                    <tbody>
                    {authors.map((author) => (
                        <tr
                            key={author.id}
                            className={`border-b hover:bg-gray-50 ${
                                edit === author.id ? "bg-blue-50" : "bg-white"
                            }`}
                        >
                            <td className="py-3 px-6">
                                {edit === author.id ? (
                                    <input
                                        className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                        ref={authorInputRef}
                                        value={author.name}
                                        onChange={(event) => handleChange(event, author)}
                                        onKeyDown={(event) => handleKeyDown(event, author)}
                                        onBlur={handleBlur}
                                    />
                                ) : (
                                    <span>{author.name}</span>
                                )}
                            </td>
                            <EditButton handleEdit={handleEdit} id={author.id}/>
                            <DeleteButton handleDelete={handleDelete} id={author.id}/>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <ModalButton handleModalStatus={handleModalStatus}/>
                <ModalForm
                    submitNew={submitNewAuthor}
                    name={authorName}
                    handleName={handleAuthorName}
                    modalOpen={modalOpen}
                    handleModalStatus={handleModalStatus}
                    title="Genre"
                />
                {flashMessage && <FlashMessage
                    message={flashMessage}
                    duration={2000}
                    onClose={handleCloseFlashMessage}
                />
                }
            </div>
        </>
    )
}

export default AdminAuthors

